module.exports = __webpack_public_path__ + "99b59389a5a83c8cc36a542be076bc30.png";